
import { CalcsResults } from './calculos/calcs-results.model';
import { Fechamento } from './fechamento.model';
import { Pessoa } from './pessoa.model';
import { Configuracoes } from './configuracoes.model';
import { CalcEntity } from './calcEntity.model';

export class CalcVida {

    vigenciaIni: string
    loaded?: boolean
    corretoraId?: string
	ramo?: number
	filaSaida?: number
	ID?: string
	aplicacaoId?: string
    debugLog?: boolean
    fechamento?: Fechamento
    segurado: Pessoa
    results?: CalcsResults
    configuracoes: Configuracoes
    calculos?: CalcEntity[]

    constructor(isDraft?){

        this.configuracoes = new Configuracoes();
        this.segurado = new Pessoa();
        this.calculos = [new CalcEntity()];

        if(!isDraft) {
            this.results = new CalcsResults();
            this.loaded = false;
        }

    }

}